import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeading, PageTabs } from '../components/PageHeader';
import { AccountTab } from '../components/Settings/AccountTab';
import { StylingTab } from '../components/Settings/StylingTab';

type SettingsTab = 'styling' | 'account';

const TABS: { id: SettingsTab; icon: string }[] = [
  { id: 'styling', icon: 'droplet' },
  { id: 'account', icon: 'user' },
];

export function SettingsPage() {
  const { t } = useTranslation('settings');
  const [searchParams, setSearchParams] = useSearchParams();
  // Styling is the first tab and the default (no ?tab).
  const activeTab: SettingsTab = searchParams.get('tab') === 'account' ? 'account' : 'styling';

  // Same shell, heading and tabs as Agency.
  return (
    <div className="mobile-page-shell cpt-root w-full px-6 pt-5 pb-6 min-w-0" style={{ display: 'flex', flexDirection: 'column', gap: 14, boxSizing: 'border-box' }}>
      <PageHeading title={t('title')} />

      <PageTabs
        tabs={TABS.map((tab) => ({ id: tab.id, icon: tab.icon, label: t(`tabs.${tab.id}`) }))}
        active={activeTab}
        onChange={(id) => setSearchParams(id === 'styling' ? {} : { tab: id })}
      />

      {activeTab === 'styling' ? <StylingTab /> : <AccountTab />}
    </div>
  );
}
